import api from 'axios'

export default {
  fetch: function (context) {
    return api.get('/api/newsfeed')
            .then(function (response) {
              context.commit('set', response.data)
            })
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/newsfeed/actions.js